<template>
  <div :key="guest_id">

    <page-title :page-title="formName" :add-navbar-button-offset="true"></page-title>

    <div class="pt-6 px-md-8 px-4" v-if="loadingForm">
      <v-container fluid>
        <v-row>
          <v-col class="pa-0">
            <v-skeleton-loader type="text@2, sentences, text@3, image, text@3"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <form-fill-core
        v-if="!loadingForm"
        :form="myForm"
        :guest_form="true"
        @savingComplete="onSavingComplete"
        ref="formFillCore"
    />

    <!-- Success dialog when registration is completed -->
    <v-dialog v-model="savingComplete" max-width="400" scrollable persistent>
      <v-card>
        <v-card-text class="pt-4 text-center">
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
          <p class="mt-5">Uw registratie is verstuurd.</p>
          <p class="text-caption text--secondary">U kunt nu dit venster sluiten.</p>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import PageTitle from "@/components/Pagetitle";
import FormFillCore from "@/views/forms/FormFillCore.vue";
import axios from "axios";

export default {
  name: "FormFillGuest",
  components: {
    FormFillCore,
    PageTitle,
  },
  props: {
    guest_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      myForm: null,
      loadingForm: true,
      savingComplete: false,
    }
  },
  async mounted() {
    await this.loadForm()
  },
  computed: {
    formName() {
      if (this.myForm) {
        return this.myForm.form_name ? this.myForm.form_name : ''
      }
      else {
        return 'Laden..'
      }
    },
  },
  methods: {
    async loadForm() {
      this.loadingForm = true
      // Fetch results form the API
      await axios
          .get('api/guest/form/' + this.guest_id)
          .then(response => {
            this.myForm = response.data
          })
          .catch(error => {
            console.log(error)
            this.loadingForm = false;
          })
          .finally(() => this.loadingForm = false)
      this.loadingForm = false
    },
    onSavingComplete() {
      this.savingComplete = true;
    },
    confirmClose() {
      let formFillCore = this.$refs.formFillCore;
      let unsavedChanges = formFillCore ? formFillCore.unsavedChanges : false;

      if (unsavedChanges) {
        return window.confirm('Wilt u deze pagina verlaten? Indien u wijzigingen heeft aangebracht gaan deze verloren.');
      }
      return true;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.confirmClose()) {
      this.$toast.clear();
      next();
    }
    else {
      next(false);
    }
  },
}
</script>

<style lang="scss">

</style>